

























import { Component, Vue } from 'vue-property-decorator';
import { SysModule } from '@/store/modules/sys';
import { AppModule } from '@/store/modules/app';
import SysAdminUserList from '@/components/Users/SysAdminUserList.vue'
import Alert from '@/components/Shared/Alert.vue'
import GiganautVue from '@/components/Shared/GiganautVue'


@Component({

	name: 'SysAdminUsers',
  	components: { SysAdminUserList, Alert }
})
export default class extends GiganautVue {

	created() {
		SysModule.getSysAdminUsers();
  	}

  	get loading() {
		return SysModule.loading;
  	}
}
